/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/23/20
 * Time: 12:27 PM
 */

import React, {Component} from 'react';
import {Route, Switch, withRouter} from "react-router";
import * as constants from "../../const/constants";
import Teacher from "../../views/home/teacher/Teacher";
import MyClass from "../../views/home/my-class/MyClass";
import MyLessons from "../../views/home/my-lessons/MyLessons";
import MyCourses from "../../views/home/my-courses/MyCourses";
import JoinClass from "../../views/home/join-class/JoinClass";
import JoinClasses from "../../views/home/join-classes/JoinClasses";
import ViewClass from "../../views/home/view-lecture/ViewLecture";
import {ViewCourseV2} from "../../views/home/view-course/ViewCourseV2";
import Lessons from "../../views/home/lesson/Lessons";
import ViewLesson from "../../views/home/lesson/view-lesson/ViewLesson";
import Profile from "../../views/home/profile/Profile";
import Cookies from "js-cookie";
import * as actionCreator from "../../store/domain/auth/action";
import * as actionStudentCreator from "../../store/domain/student/action";
import * as studentService from "../../services/student";
import {connect} from "react-redux";
import SiteLoader from "../../components/Loader/SiteLoader";
import * as commonFunc from "../../utils/commonFunc";
import PaymentAuthorize from "../../views/home/payment-authorize/PaymentAuthorize";
import Papers from '../../views/home/paper/Papers';
import ViewPaper from "../../views/home/paper/view-paper/ViewPaper";
import StartPaper from '../../views/home/paper/start-paper/StartPaper';
import StartEssayPaper from '../../views/home/paper/start-paper/StartEssayPaper';
import FinishedPaper from '../../views/home/paper/finish-paper/Finish-paper';
import Exams from '../../views/home/exams/Exams';
import LeaderBoard from '../../views/home/paper/leader-board/LeaderBoard';
import GetComment from '../../views/home/paper/getComment/getComment';
import CompareAnswers from '../../views/home/paper/compare-answers/CompareAnswers';
import JoinClassError from "../../views/home/join-class/JoinClassError";
import AllTeachersView from "../../views/home/landing/version-01/all-teachers/AllTeachersView";

import Help from "../../views/home/help/Help";
import ViberLayout from "../../views/home/landing/vibernets-layout/ViberLayout";
import TeacherCoursesV1 from "../../views/home/view-course/TeacherCoursesV1";
import Certificates from "../../views/home/certificates/Certificates";
import PreviewCertificate from "../../views/home/preview-certificate/PreviewCertificate";

class App extends Component {

    fetchUserDetails = async () => {
        await studentService.fetchUserDetails()
            .then(response => {
                if (response.success) {
                    this.props.userDetailsHandler(response.body);
                    this.props.setUserType(1);
                    return;
                } else {
                    this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
                }
                commonFunc.notifyMessage(response.message, response.status);
            })
    };


    render() {
        let access_token = Cookies.get(constants.ACCESS_TOKEN);
        let {userType, userObj} = this.props;
        this.props.setUserType(!access_token ? 0 : userObj ? 1 : -1);

        if (access_token && !userObj) {
            this.fetchUserDetails();
        }
        console.log('Layout Here')
        return (
            <div>
                {
                    userType !== -1 ?
                        <Switch>

                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_TEACHER_ROUTE}/:teacher_name`}
                                render={props => <Teacher {...props} />}/>

                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`}
                                render={props => <ViewCourseV2 {...props} />}/>


                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_HELP_ROUTE}`}
                                render={props => <Help {...props} />}
                            />

                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_MY_CLASS_ROUTE}`}
                                    render={props => <MyClass {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_MY_LESSONS_ROUTE}`}
                                    render={props => <MyLessons {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_MY_COURSE_ROUTE}`}
                                    render={props => <MyCourses {...props} />}
                                />
                            }

                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_PROFILE_ROUTE}`}
                                    render={props => <Profile {...props} />}/>
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ERROR_ROUTE}`}
                                    render={props => <JoinClassError {...props} />}/>
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_PAYMENT_AUTHORIZE}`}
                                    render={props => <PaymentAuthorize {...props} />}/>
                            }

                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`}
                                render={props => <ViewClass {...props} />}
                            />


                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE_PAYMENT}/:class_name`}
                                render={props => <ViewClass {...props}/>}
                            />

                            {/*<Route*/}
                            {/*    path={`${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_URL_ROUTE}/:join_code`}*/}
                            {/*    render={props => <ViewClass {...props} />}/>*/}

                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_URL_ROUTE}/:join_code`}
                                render={props => <JoinClasses {...props} />
                                }
                            />


                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ROUTE}`}
                                    render={props => <JoinClass {...props} />}/>
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_VIEW_LESSON_ROUTE}`}
                                    render={props => <Lessons {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_VIEW_SELECTED_LESSON_ROUTE}`}
                                    render={props => <ViewLesson {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_VIEW_PAPER_ROUTE}`}
                                    render={props => <Papers {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_VIEW_SELECTED_PAPER_ROUTE}`}
                                    render={props => <ViewPaper {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_START_SELECTED_PAPER_ROUTE}`}
                                    render={props => <StartPaper {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_START_ESSAY_SELECTED_PAPER_ROUTE}`}
                                    render={props => <StartEssayPaper {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.FINISHED_PAPER_ROUTE}`}
                                    render={props => <FinishedPaper {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_EXAM_ROUTE}`}
                                    render={props => <Exams {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_VIEW_LEADERBOARD_ROUTE}`}
                                    render={props => <LeaderBoard {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_COMPARE_ANSWERS_ROUTE}`}
                                    render={props => <CompareAnswers {...props} />}
                                />
                            }
                            {
                                userType === 1 &&
                                <Route
                                    path={`${constants.BASE_ROUTE}${constants.HOME_GET_TEACHER_COMMENT_ROUTE}`}
                                    render={props => <GetComment {...props} />}
                                />
                            }
                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_ALL_TEACHER_ROUTE}`}
                                render={props => <AllTeachersView {...props} />}
                            />

                            {/*<Route*/}
                            {/*    path={`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`}*/}
                            {/*    render={props => <Index {...props} />}/>*/}

                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_COURSE_ROUTE}`}
                                render={props => <TeacherCoursesV1 {...props} />}/>

                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_CERTIFICATES_ROUTE}`}
                                render={props => <Certificates {...props} />}/>

                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_PREVIEW_CERTIFICATE_ROUTE}`}
                                render={props => <PreviewCertificate {...props} />}/>

                            <Route
                                path={`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`}
                                render={props => <ViberLayout {...props} />}/>


                            {/*<Redirect*/}
                            {/*    to={`${userType === 1 ? `${constants.BASE_ROUTE}${constants.HOME_MY_CLASS_ROUTE}` : `${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`}`}/>*/}
                        </Switch>
                        : <SiteLoader/>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    userObj: state.student.userObj
});
const mapDispatchToProps = (dispatch) => ({
    setUserType: data => dispatch(actionCreator.setUserType(data)),
    userDetailsHandler: data => dispatch(actionStudentCreator.userDetailsHandler(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
